<template>
    <div class="mt-5">
        <div v-if="reloading" class="spinner element-spinner d-flex flex-column justify-content-center align-items-center">
            <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
        </div>
        <div v-if="showQueries" v-html="this.query">{{ this.query }}</div>
        <template v-if="!!missed_accounts.length">
            <div v-for="missed_account in missed_accounts" class="missed-accounts my-3">There are no accounts connected for {{missed_account}}. Either connect an account or change the metrics/remove this section in the builder.</div>
        </template>
        <div v-if="nodata" class="nodata-container p-5 text-center">
            <div v-if="errors" class="empty-data"><img :src="$store.state.app_url+'/images/errors.gif'"></div>
            <div v-else class="empty-data"><img :src="$store.state.app_url+'/images/nodata.svg'"></div>
        </div>
        <div v-show="!nodata">
            <h6 class="section-name mb-5 text-uppercase">{{chartData.name}}</h6>
            <div class="chart-container"></div>
            <traffic-trends v-if="chart_abbr=='traffic_trends'" ref="trafficTrendsRef" :isGuest="isGuest"></traffic-trends>
        </div>
        <details-card v-if="isBuilt && has_annotations" :detailsCard="annotations" :isBuilt="isBuilt"></details-card>
    </div>
</template>

<script>
    import trafficTrends from './chartTypes/TrafficTrends.vue';

    export default {
        props: ['isBuilt', 'hasSkb', 'chartData', 'isGuest'],
        components: {
            'trafficTrends': trafficTrends
        },
        created(){
            this.prefixed_id = this.isArchive ? this.chartData.archive_id : this.chartData.report_id;
            this.report_id = this.chartData.report_id;
            this.prefixed_element_id = this.chartData.report_element_id;
            this.filter_element = this.chartData.element_configurations.filter_element;
            this.show_index_values = !!this.chartData.element_configurations.show_index_values;
            this.index_name = this.chartData.element_configurations.select_index_name;
            event_bus.$on('current_dwm', () => {
                this.current_dwm = this.$store.state.current_dwm;
                event_bus.$emit('reloading', true);
            });
            this.missed_accounts = this.checkAccounts(this.chartData);
        },
        data() {
            return {
                missed_accounts:[],
                chart:null,
                isArchive:this.$store.state.isArchive,
                chart_abbr:this.chartData.element_abbreviation,
                has_annotations:false,
                show_index_values:false,
                index_name:'',
                annotations:{},
                filter_element: null,
                params:{
                    'labelColor':'#ACACAC',
                    'titlelColor':'#ACACAC',
                    'axisBaseColor':'#c2c9d1'
                },
                nodata:false,
                errors:false,
                query:'',
                showQueries:    this.$store.state.showQueries,
                reloading:true
            }
        },
        mounted() {
            this.fetchServerData();
            event_bus.$on('reloading', () => {
                this.reloading = true;
                this.fetchServerData();
            });
        },
        methods: {
            fetchServerData(){
                if(this.isBuilt){
                    let dates = this.$store.state.current_dates;
                    let date_key = dates.date_from + '__' + dates.date_to + '__' + dates.date_compare_from + '__' + dates.date_compare_to;
                    let chartContainer = $(this.$el).find('div.chart-container')[0];
                    const vueInstance = this;
                    let params = {
                        'isArchive':this.isArchive,
                        'prefixed_id': this.prefixed_id,
                        'report_id': this.report_id,
                        'element_abbr':this.chartData.element_abbreviation,
                        'dwm':this.$store.state.current_dwm,
                        'dates':this.$store.state.current_dates,
                        'element_id': this.chartData.element_id,
                        'prefixed_element_id': this.prefixed_element_id,
                        'element_name':this.chartData.name,
                        'metrics': this.chartData.metrics,
                        'accounts': this.chartData.accounts,
                        'filter_element':this.filter_element,
                        'show_index_values': this.show_index_values,
                        'index_name':this.index_name,
                        'showQueries':this.showQueries,
                        'hasSkb':this.hasSkb,
                    };

                    axios.get(`/api/reporting/annotations/?params=${JSON.stringify(params)}`).then((annotations) => {
                        this.annotations = annotations.data;
                        this.has_annotations = this.$store.state.current_dwm == 'daily' && Object.keys(this.annotations).length;
                        params.annotations = JSON.stringify(annotations.data);
                        axios.post('/api/reporting/element', params).then((response) => {
                            this.data = response.data;
                            if(response.data['nodata']){
                                this.nodata = true;
                                this.errors = response.data['errors'];
                                $(this.$el).find('div.chart-container').html('');
                            }
                            else{
                                this.chart = Highcharts.chart(chartContainer, this.getChartOptions(response.data, this.params, this.annotations));
                                this.nodata = false;
                            }

                            this.query = response.data['query'];
                            event_bus.$emit('update_details', true);
                            this.reloading = false;
                        });
                    });
                }
            },
            getChartOptions(chartData, params, annotations) {
                const vueInstance = this;
                let chartContainer = $(this.$el).find('div.chart-container');
                let functionSuffix = _.camelCase(this.chartData.element_abbreviation);
                let functionName   = 'getOptionsFor' + functionSuffix.charAt(0).toUpperCase() + functionSuffix.slice(1);
                chartData['categories'].length;
                let refPrefix = functionSuffix + 'Ref';

                if(!refPrefix || !this.$refs[refPrefix]){
                    return;
                }

                let options        = this.$refs[refPrefix][functionName](chartData, params, annotations, vueInstance);
                if (!options.chart) {
                    options.chart = {};
                }
                options.chart.height = 440;
                options.title = {
                    text: ''
                };
                options.subtitle = {
                    text: ''
                };
                options.credits = {
                    enabled: false
                };
                options.exporting = {
                    enabled: false
                };
                options.legend = $.extend(options.legend, {
                    verticalAlign: 'bottom',
                    backgroundColor: 'transparent',
                    maxHeight:80,
                    itemMarginTop: 5,
                    itemMarginBottom: 5,
                    alignColumns:false
                });
                if(this.chartData.num_x_axis == 1){
                    options.xAxis.lineWidth = 2;
                    //options.xAxis.lineColor = params.axisColor;
                    options.xAxis.tickColor = '#FFFFFF';
                };
                if(this.chartData.num_x_axis == 2){
                    options.xAxis[0].lineWidth = 2;
                    //options.xAxis[0].lineColor = params.axisColor;
                    options.xAxis[0].tickColor = '#FFFFFF';

                    options.xAxis[1].lineWidth = 2;
                    //options.xAxis[1].lineColor = params.axisColor;
                    options.xAxis[1].tickColor = '#FFFFFF';
                };
                if(this.chartData.num_y_axis == 1){
                    options.yAxis.endOnTick = false;
                    if(this.chartData.element_abbreviation != 'back_to_back'){
                        options.yAxis.min = 0;
                    }
                    options.yAxis.lineWidth = 2;
                    options.yAxis.gridLineWidth = 0;
                    options.yAxis.showFirstLabel = false;
                    options.yAxis.lineWidth = 2;
                    //options.yAxis.lineColor = params.axisColor;
                    options.yAxis.tickColor = '#FFFFFF';
                };
                if(this.chartData.num_y_axis == 2){
                    options.yAxis[0].endOnTick = true;
                    options.yAxis[0].min = 0;
                    options.yAxis[0].lineWidth = 2;
                    options.yAxis[0].gridLineWidth = 0;
                    options.yAxis[0].showFirstLabel = false;
                    options.yAxis[0].lineWidth = 2;
                    options.yAxis[0].tickColor = '#FFFFFF';

                    options.yAxis[1].endOnTick = true;
                    options.yAxis[1].min = 0;
                    options.yAxis[1].lineWidth = 2;
                    options.yAxis[1].gridLineWidth = 0;
                    options.yAxis[1].showFirstLabel = false;
                    options.yAxis[1].tickColor = '#FFFFFF';
                };
                options.plotOptions.series.events.legendItemClick = function (e) {
                    let c = e.target.visible ? 0 : 1;
                    let index = e.target['index'];
                    let offset = vueInstance.chart.series.length / 2;
                    let checkbox = chartContainer.closest('div.row').find('div.select-all');
                    let disabled_num = 0;
                    let length = vueInstance.chart.series.length;
                    let isStack = vueInstance.chartData.element_abbreviation == 'stack_bar';
                    let step = vueInstance.params.yoy_comparison && isStack ? 2 : 1;

                    if (c == 0) {
                        checkbox.removeClass('on').addClass('off');
                    }
                    else {
                        let check = true;
                        let start = 0;
                        for (var i = start; i < vueInstance.chart.series.length; i += step) {
                            if (vueInstance.chart.series[i] != e.target && !vueInstance.chart.series[i].visible) {
                                check = false;
                            }
                        }
                        if (check && (c == 1)) {
                            checkbox.removeClass('off').addClass('on');
                        }
                    }
                    for (i = 0; i < vueInstance.chart.series.length; i += step) {
                        if (i == index) {
                            vueInstance.items[i] = c;
                            if(step == 2){
                                vueInstance.items[i+1] = c;
                                vueInstance.chart.series[i+1].setVisible(!!c, false);
                            }
                        }
                        else {
                            vueInstance.items[i] = vueInstance.chart.series[i].visible ? 1 : 0;
                            if(step == 2){
                                vueInstance.items[i+1] = vueInstance.items[i];
                                vueInstance.chart.series[i+1].setVisible(!!vueInstance.items[i], false);
                            }
                        }
                        if(vueInstance.items[i] == 0){
                            disabled_num += step;
                        }
                    }
                    if(disabled_num == length){
                        vueInstance.chart.update({
                            chart: {
                                ignoreHiddenSeries: false
                            }
                        });
                    }
                    else{
                        vueInstance.chart.update({
                            chart: {
                                ignoreHiddenSeries: true
                            }
                        });
                    }
                };

                setTimeout(function(){
                    vueInstance.setEventHandlers();
                }, 50);

                return options;
            },
            setEventHandlers(){
                const vueInstance = this;
                let chartContainer = $(this.$el).find('div.chart-container')[0];
                let checkbox = $(chartContainer).closest('div.row').find('div.select-all');
                if(this.check_all){
                    checkbox.addClass('on').removeClass('off');
                }
                else{
                    checkbox.addClass('off').removeClass('on');
                }

                $(chartContainer).closest('div.row').find('div.select-all').find('i').off('click').click(function () {
                    var $this = $(this);
                    var div = $this.closest('div.select-all');
                    var l = !!vueInstance.chart ? vueInstance.chart.series.length : 0;
                    if (div.hasClass('off')) {
                        vueInstance.chart.update({
                            chart: {
                                ignoreHiddenSeries: true
                            }
                        });
                        div.addClass('on').removeClass('off');
                        for (var i = 0; i < l; i++) {
                            vueInstance.chart.series[i].setVisible(true, false);
                            vueInstance.items[i] = 1;
                        }
                    } else {
                        vueInstance.chart.update({
                            chart: {
                                ignoreHiddenSeries: false
                            }
                        });
                        div.addClass('off').removeClass('on');
                        for (var i = 0; i < l; i++) {
                            vueInstance.chart.series[i].setVisible(false, false);
                            vueInstance.items[i] = 0;
                        }
                    }
                    if(l > 0){
                        vueInstance.chart.redraw();
                    }
                });
            }
        }
    }
</script>
<style lang="scss" scoped>
    div.nodata-container{
        background-color:white;
    }
    h1.highlights{
        font-size:5rem;
    }
</style>
